import { Controller } from "@hotwired/stimulus";
import Backup from "@/controllers/store_audio/backup.js";
import { DirectUpload } from "@rails/activestorage";

export default class extends Controller {
  static values = { consultationId: Number };
  static targets = ["restoreTemplate", "audioInput", "form"];

  async connect() {
    this.backup = new Backup(this.consultationIdValue);
    this.recording = await this.backup.getRecording();
    if (this.recording) {
      const restoreClone = this.restoreTemplateTarget.content.cloneNode(true);
      this.element.appendChild(restoreClone);
      document.addEventListener(
        "store-audio--recording:prevent-backup",
        this.remove.bind(this),
        { once: true }
      )
    }
  }

  disconnect() {
    document.removeEventListener(
      "store-audio--recording:prevent-backup",
      this.remove.bind(this)
    )
  }

  remove() {
    this.element.remove();
  }

  upload(event) {
    event.preventDefault();
    event.currentTarget.disabled = true;

    const audioFile = new File([this.recording.blob], "record");

    const upload = new DirectUpload(
      audioFile,
      this.audioInputTarget.dataset.directUploadUrl,
      this,
    );

    upload.create(async (error, blob) => {
      if (error) {
        console.log("fail");
      } else {
        await this.backup.deleteRecording();
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("value", blob.signed_id);
        hiddenField.name = this.audioInputTarget.name;

        this.formTarget.appendChild(hiddenField);
        this.formTarget.requestSubmit();
      }
    });
  }
}
